import { getCoreUtils } from "../../../Admin/kReusableCoreTS/kCoreHandler";

/** Pure menu navigation shared with conversation message navigation. */
export class AppMenuRules {
    public static readonly Attr: string = "data-wac-menu";
    public static Move = (At: number, Count: number, Key: string): number => {
        if (getCoreUtils().KErrorMode === true) { return -1; }
        try {
            if (Count <= 0) { return -1; }
            if (Key === "ArrowDown") { return (At + 1 + Count) % Count; }
            if (Key === "ArrowUp") {
                if (At < 0) { return Count - 1; }
                return (At - 1 + Count) % Count;
            }
            if (Key === "Home") { return 0; }
            if (Key === "End") { return Count - 1; }
            return -1;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMenuRules.Move");
            return -1;
        }
    };
}
